var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alpha",on:{"mousedown":_vm.mouseEvents}},[_c('div',{staticClass:"gradient",style:(_vm.style)}),_c('div',{staticClass:"alpha-area has-transparency-layer"},[_c('div',{ref:"alphaMaskRef",staticClass:"alpha-mask"},[_c('div',{staticClass:"picker-pointer",style:(_vm.pointerStyle)})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }